import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";

export default function CaptureLoginPasswordEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789012")
        .submit();

    return <LoginPage data={ data } />
}